import { render } from "./Video.vue?vue&type=template&id=9f08d056&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=9f08d056&lang=scss&scoped=true"

import exportComponent from "/Users/majunhua/Desktop/admin-zsrb/activity_aliplayer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f08d056"]])

export default __exports__